AuditService.$inject = ['$resource', 'StoresService'];

function AuditService($resource, StoresService) {
    const AuditList = $resource('api/audits/');
    const AuditRecord = $resource('api/audits/:key/:rowId');
    const AuditLogon = $resource('api/audits/:userName', null, {
        save: {
            method: 'POST',
            url: 'api/audits/auditLogon'
        }
    });

    this.getRecord = getRecord;
    this.getRecords = getRecords;
    this.auditLogon = auditLogon;

    function getRecord(key, rowId) {
        return AuditRecord.query({
            key,
            rowId
        }).$promise;
    }

    function getRecords(page, pageSize, dateFrom, dateTo, table, type, user) {
        return StoresService.getStore().then(store => {
            return AuditList.query({
                storeId: store.storeId,
                dateFrom,
                dateTo,
                table,
                type,
                user,
                pageSize,
                page
            }).$promise;
        });
    }

    function auditLogon(userName) {
        return AuditLogon.save({userName: userName}).$promise;
    }
}

export default AuditService;



// WEBPACK FOOTER //
// ./src/js/services/audit/index.js